import { render, staticRenderFns } from "./photo-report-review.pug?vue&type=template&id=1328297e&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./photo-report-review.scss?vue&type=style&index=0&id=1328297e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328297e",
  null
  
)

export default component.exports